//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';

//@ts-ignore
class Plugin extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'Plugin';
  }
}
Plugin.initClass();

export { Plugin };
